export const ADVANCED_QUESTION_TYPES = [
  'SECTION',
  'FILE',
  'FORMULA',
  'PAYMENT',
  'ADDRESS'
];
